import { categories } from "@/mocks/catalog";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section id="categories" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="分类速览"
          title="六大类型，先确定你的观看方向"
          description="不知道从哪看起时，先选一个大类。每个类型都标注了主要特征与大致收录量，点进去可直接跳到对应分区了解代表作品。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <a
              key={cat.anchor}
              href={`#${cat.anchor}`}
              className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors duration-300 hover:border-primary-300 hover:bg-primary-50"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <span className="text-xs text-foreground-500">收录 {cat.count} 部</span>
              </div>
              <div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="mt-1 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {cat.intro}
                </p>
              </div>
              <span className="mt-auto inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                查看{cat.name}导览
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}